<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold">
        নিকটাত্মীয়ের তালিকা
      </v-col>

      <v-col cols="6" class="text-end">
        <v-btn
          color="secondary"
          size="small"
          class="me-3 rounded-lg"
          @click="openModal"
        >
          <v-icon start>mdi-plus-circle-outline</v-icon>
          যোগ করুন
        </v-btn>
      </v-col>

      <!-- Table -->
      <v-col cols="12">
        <v-table class="language-table">
          <thead>
            <tr>
              <th>নাম</th>
              <th>সম্পর্ক</th>
              <th>মোবাইল নম্বর</th>
              <th>জন্ম তারিখ</th>
              <th width="120">অ্যাকশন</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="NomineeData.length === 0">
              <td colspan="6" class="text-center py-6">কোন তথ্য পাওয়া যায়নি</td>
            </tr>

            <tr v-for="(item, index) in NomineeData" :key="index">
              <td>{{ item.name_bn }}</td>
              <td>{{ item.relation }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.dob }}</td>

              <td>
                <div class="d-flex align-center">
                  <v-btn icon size="small" color="primary" variant="text">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>

                  <v-btn icon size="small" color="red" variant="text">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>

    <!-- Modal -->
    <form>
      <InsertModal ref="Modal" title="নিকটাত্মীয়ের তথ্য" :width="900">
        <template #modalBody>
          <v-row>
            <!-- NID Number -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.nid_number"
                label="এনআইডি নম্বর"
                placeholder="এনআইডি নম্বর লিখুন"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Date of Birth -->
            <v-col cols="12" md="6">
              <v-menu
                v-model="DobMenu"
                :close-on-content-click="false"
                location="bottom"
              >
                <template #activator="{ props }">
                  <v-text-field
                    :model-value="formatDate(form.dob)"
                    label="জন্মতারিখ"
                    prepend-inner-icon="mdi-calendar"
                    variant="outlined"
                    density="comfortable"
                    readonly
                    class="mb-3"
                    v-bind="props"
                  />
                </template>

                <v-date-picker
                  style="margin-top: -20px"
                  v-model="form.dob"
                  color="primary"
                  hide-header
                  @update:modelValue="DobMenu = false"
                />
              </v-menu>
            </v-col>

            <!-- Relation -->
            <v-col cols="12">
              <v-select
                v-model="form.relation"
                :items="relations"
                label="সম্পর্ক *"
                placeholder="সম্পর্ক বাছাই করুন"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Bangla Name -->
            <v-col cols="12">
              <v-text-field
                v-model="form.name_bn"
                label="নাম (বাংলা) *"
                placeholder="বাংলা নাম"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- English Name -->
            <v-col cols="12">
              <v-text-field
                v-model="form.name_en"
                label="নাম (ইংরেজি) *"
                placeholder="ইংরেজি নাম"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Occupation -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.occupation"
                label="জন্মনিবন্ধন নম্বর"
                placeholder="জন্মনিবন্ধন নম্বর লিখুন"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- Mobile -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.mobile"
                label="মোবাইল নম্বর *"
                placeholder="01XXXXXXXXX"
                variant="outlined"
                density="comfortable"
              >
                <template #prepend-inner>
                  <span class="mr-2">+88</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>

        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                size="large"
                class="me-3 rounded-lg"
                type="submit"
              >
                <v-icon start> mdi-content-save-outline </v-icon>
                সংরক্ষণ করুন
              </v-btn>

              <v-btn
                color="grey-darken-1"
                variant="outlined"
                size="large"
                class="rounded-lg"
                @click="resetForm"
              >
                <v-icon start>mdi-refresh</v-icon>
                রিসেট
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "NomineeComponent",

  components: {
    InsertModal,
  },

  data() {
    return {
      NomineeData: [],

      relations: ["পিতা", "মাতা", "ভাই", "বোন", "চাচা", "মামা", "খালা", "ফুফু"],
      DobMenu: false,
      form: {
        nid_number: "",
        dob: "",
        relation: null,
        name_bn: "",
        name_en: "",
        occupation: "",
        mobile: "",
      },
    };
  },

  methods: {
    openModal() {
      this.$refs.Modal.openModal();
    },

    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${day}-${month}-${year}`;
    },

    resetForm() {
      this.form = {
        nid_number: "",
        dob: "",
        relation: "",
        name_bn: "",
        name_en: "",
        occupation: "",
        mobile: "",
      };
    },
  },
};
</script>
